// extracted by mini-css-extract-plugin
module.exports = {"page":"LayoutMobileBackHeader_page__cFyTr","header":"LayoutMobileBackHeader_header__1cdQf","body":"LayoutMobileBackHeader_body__sgEU6"};